module.exports = __webpack_public_path__ + "img/icon_tg.894018a5.svg";